import { createSelector } from 'reselect'
import { getPageData, getPageParams } from 'selectors/page'
import {
  getIsAdmin,
  getUserID,
  isAuthenticated as getIsAuthenticated,
} from 'selectors/user/session'
import { CollectionMetadata } from '../types/Collection'

export const getCollectionData = createSelector(
  getPageData,
  (data): CollectionMetadata => data.collectionData || {}
)

export const getCollectionOwnerName = createSelector(
  getCollectionData,
  (collection): string => collection.ownerName || ''
)

export const getCollectionId = createSelector([getPageParams], (params): number => {
  return params.collectionId || 0
})

export const getCollectionTitle = createSelector(
  getCollectionData,
  (collection): string => collection.title || ''
)

export const getCollectionTypes = createSelector(
  getCollectionData,
  (collection): ReadonlyArray<string> => collection.collectionTypes || []
)

export const getCreatedAt = createSelector(
  getCollectionData,
  (collection): number => collection.createdAt || 0
)

export const getIsCollectionPrivate = createSelector(
  getCollectionData,
  (collection): boolean => collection.isPrivate || false
)

export const getIsCollectionPrintView = createSelector(
  getCollectionData,
  (collection): boolean => collection.isPrintsView || false
)

export const getIsUsersCollection = createSelector(
  [getPageParams, getUserID, getIsAuthenticated],
  (params, userId, isAuthenticated): boolean =>
    (isAuthenticated && Number(userId) === Number(params.ownerId || 0)) || false
)

export const getHasValidPermissions = createSelector(
  [getIsUsersCollection, getIsAdmin],
  (isUsersCollection, isAdmin): boolean => isUsersCollection || isAdmin || false
)
